import { appUser } from "@duress/shared";
import { apiFetch, ApiError, parseProblem, API_BASE_URL } from "@/lib/api-client";

// App user roster upload is deliberately its own small endpoint, not part of
// UploadPeriodDialog's multi-file period upload -- the roster is a snapshot
// ("who's registered right now"), not a period-scoped CSV, so it doesn't fit
// that dialog's month-bucketing model. See app-user.routes.ts (backend).

export async function getAppUsers(clientId: string): Promise<appUser.AppUserData> {
  return apiFetch(`/clients/${clientId}/app-users`, appUser.AppUserDataSchema);
}

async function fetchOrExplain(input: string, init: RequestInit): Promise<Response> {
  try {
    return await fetch(input, init);
  } catch {
    throw new Error("The upload didn't complete — check your connection and try again.");
  }
}

export async function uploadAppUsers(clientId: string, file: File): Promise<appUser.AppUserData> {
  const formData = new FormData();
  formData.append("app_user_csv", file);

  const res = await fetchOrExplain(`${API_BASE_URL}/v1/clients/${clientId}/app-users`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });
  if (!res.ok) throw new ApiError(res.status, await parseProblem(res));
  const json: unknown = await res.json();
  return appUser.AppUserDataSchema.parse(json);
}
